import { render } from "./DataStudioContainer.vue?vue&type=template&id=a5454a6a&scoped=true"
import script from "./DataStudioContainer.vue?vue&type=script&lang=js"
export * from "./DataStudioContainer.vue?vue&type=script&lang=js"

import "./DataStudioContainer.vue?vue&type=style&index=0&id=a5454a6a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a5454a6a"]])

export default __exports__